import { useCallback } from 'react';
import { useRenameAsset } from '@frameio/assets/operations';
import { useAssetParentFolderId } from '@frameio/assets/shared';
import { useFolderNameFragment } from '@frameio/graphql-client/generated';
import { useFolderPermissions } from '@frameio/permissions';
import { useFolderDndNamespace } from '../../contexts';
import { EditableName, type EditableNameProps } from '../TreeItem/EditableName';
import TEXT from './generated/TEXT/FolderName';

export function FolderName({ focused, isActive, item }: EditableNameProps) {
  const { data: folder } = useFolderNameFragment({
    from: {
      __typename: 'Asset',
      id: item.id,
    },
  });
  const parentFolderId = useAssetParentFolderId(item.id);
  const canUpdateAsset = useFolderPermissions({
    check: 'canUpdateChildren',
    folderId: parentFolderId,
  });
  const { renameAsset } = useRenameAsset();
  const folderDndNamespace = useFolderDndNamespace();

  const handleRenameSubmit = useCallback(
    (submitted: string) => {
      renameAsset({
        assetId: item.id,
        newName: submitted,
        oldName: folder.name ?? '',
      });
    },
    [folder.name, item.id, renameAsset]
  );

  return (
    <EditableName
      ariaLabel={TEXT.editNameLabel}
      canUpdate={canUpdateAsset && folderDndNamespace !== null}
      focused={focused}
      isActive={isActive}
      item={item}
      onRenameSubmit={handleRenameSubmit}
      originalName={folder.name}
    />
  );
}

TEXT.DEFINE({
  /** Aria label for the inline rename input for the folder */
  editNameLabel: 'Rename folder',
});
